
import { createContext } from 'react';
import { EmailContextType } from '../types';

export const EmailContext = createContext<EmailContextType | null>(null);
